export const productCategories = [
  {
    name: 'Fragancias para Hombre',
    image:
      'https://readdy.ai/api/search-image?query=elegant%20glass%20perfume%20bottle%20for%20men%20on%20light%20marble%20surface%20with%20warm%20natural%20daylight%20soft%20amber%20tones%20clean%20minimal%20luxury%20fragrance%20photography%20bright%20airy%20composition%20no%20dark%20shadows&width=600&height=700&seq=cat-men-fragrance-bright&orientation=portrait',
    link: '/fragancias',
  },
  {
    name: 'Fragancias para Mujer',
    image:
      'https://readdy.ai/api/search-image?query=elegant%20crystal%20perfume%20bottle%20for%20women%20with%20soft%20pink%20rose%20petals%20on%20marble%20surface%20feminine%20luxury%20fragrance%20photography%20warm%20golden%20lighting%20delicate%20composition&width=600&height=700&seq=cat-women-fragrance&orientation=portrait',
    link: '/fragancias',
  },
  {
    name: 'Frascos para Perfumería',
    image:
      'https://readdy.ai/api/search-image?query=collection%20of%20empty%20luxury%20glass%20perfume%20bottles%20in%20different%20shapes%20and%20sizes%20on%20clean%20white%20background%20minimal%20product%20photography%20elegant%20packaging%20design%20soft%20lighting&width=600&height=700&seq=cat-bottles&orientation=portrait',
    link: '/contact',
  },
  {
    name: 'Fragancias Industriales',
    image:
      'https://readdy.ai/api/search-image?query=industrial%20fragrance%20production%20laboratory%20with%20large%20glass%20containers%20and%20distillation%20equipment%20scientific%20setting%20amber%20liquids%20professional%20photography%20clean%20modern&width=600&height=700&seq=cat-industrial&orientation=portrait',
    link: '/fragancias',
  },
  {
    name: 'Insumos para Perfumería Fina',
    image:
      'https://readdy.ai/api/search-image?query=premium%20perfume%20raw%20materials%20essential%20oils%20in%20amber%20glass%20bottles%20wooden%20table%20natural%20ingredients%20vanilla%20cinnamon%20flowers%20artisan%20perfumery%20supplies%20warm%20lighting&width=600&height=700&seq=cat-supplies&orientation=portrait',
    link: '/fragancias',
  },
];